import {createAction} from 'redux-act';

export const retrieveBreakNames = createAction('Retrieve break names from the backend service', () => ({}));
export const setBreakNames = createAction('Set break names in the Redux state store', ( breakNames ) => ({ breakNames }));
